import {
    ActionList,
    Badge,
    Banner,
    Button,
    ButtonGroup,
    FormLayout,
    Icon,
    Popover,
    SkeletonBodyText,
    SkeletonDisplayText,
    SkeletonThumbnail,
    Tabs,
    TextField,
    Tooltip,
} from "@shopify/polaris";
import styles from "./FormPreviewWrapper2.module.css";
import { Dispatch, FormEvent, ReactNode, SetStateAction, useCallback, useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getBundleRoute, getBundleType } from "../../apps/constants";
import {
    ArrowLeftIcon,
    StatusActiveIcon,
    MenuHorizontalIcon,
    ViewIcon,
    DuplicateIcon,
    MobileIcon,
    DesktopIcon,
} from "@shopify/polaris-icons";
import { getBoolean, scrollToTop } from "../../utilities/functions";
import { FormError } from "@shopify/react-form";
import CustomModal from "../CustomModal/CustomModal";
import { endPoints, getData, postData } from "../../utilities/networkCalls";
import { SaveBar } from "@shopify/app-bridge-react";
import { PlaceholderConfigInterface, BundleBuilderConfigInterface, ChangeEvents } from "../../apps/Bundles/Types";
import RenderError from "../RenderError/RenderError";
import {
    BundleTypes,
    fetchCollectionProducts,
    generateRandomUniqueId,
    generateSwatchConfigsFromProductMap,
    isBundleExpired,
    isBundleScheduled,
} from "../../apps/Bundles/constants";
import useBundleMixpanelHook from "../../hooks/useBundleMixpanelHook";
import SuggestFeature from "../SuggestFeature/SuggestFeature";
import ActivateSnippetModal from "../ActivateSnippetModal/ActivateSnippetModal";
import PostPublishCard from "../PostPublish/PostPublishCard";
import { AppsContext } from "../../apps/Bundles/BundlesHomePage";
import LimitReachedPopup from "../Plans/LimitReachedPopup";
import { AppConfigContext } from "../../context/AppConfigContext";
import BundleBuilderModalPreview from "./BundleBuilderModalPreview";
import BundleAsProductError from "../BundleAsProductError/BundleAsProductError";
import CalloutNudgeBanner from "../CalloutNudgeBanner";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import InfoIconOverride from "../Icons/InfoIconOverride";
import { usePlatform } from "../../hooks/usePlatform";
import { MdOutlineKeyboardCommandKey } from "react-icons/md";
import PlaceholderTemplate from "../PlaceholderTemplate/PlaceholderTemplate";
import ProductIntent from "../Intents/ProductIntent";
import ShowOnStoreModal from "../ShowOnStoreModal/ShowOnStoreModal";

type Props_FormPreviewWrapper2 = {
    bundleType: string;
    disabledTabs?: boolean;
    renderForms: ReactNode[];
    renderPreview: ReactNode;
    bundleConfig: BundleBuilderConfigInterface | PlaceholderConfigInterface;
    oldBundleConfig: BundleBuilderConfigInterface | PlaceholderConfigInterface;
    resetForm: any;
    setSelected: Dispatch<SetStateAction<number>>;
    dispatchBundleConfig: Dispatch<any>;
    loading: boolean;
    globalErrors: FormError[];
    globalDirty: boolean;
    selected: number;
    handleNext: any;
    setConfig: Dispatch<SetStateAction<any>>;
    validateForm: () => FormError[];
    submitForm: (event?: FormEvent) => Promise<void>;
    makeCleanForm: any;
    fetchBundle: (id?: string | null) => Promise<void>;
    currentActiveProduct?: string;
    setCurrentActiveProduct?: Dispatch<React.SetStateAction<string>>;
    forAiBundle?: boolean;
    formPreviewWrapperRef?: any;
    onlyPreview?: boolean;
    _setSavingBundle?: any;
    setInspectorMode?: Dispatch<React.SetStateAction<boolean>>;
    inspectorMode?: boolean;
    setPreviewType?: any;
};

const tabs = [
    {
        id: "Content-1",
        content: "Content",
        panelID: "Content-1",
    },
    {
        id: "Design-1",
        content: "Design",
        panelID: "Design-1",
    },

    {
        id: "Target-1",
        content: "Advanced",
        panelID: "Target-1",
    },
    // {
    //     id: "Settings-1",
    //     // content: "Settings",
    //     content: (
    //         <span style={{ display: "flex", alignItems: "center" }}>
    //             Settings
    //             <span
    //                 style={{
    //                     backgroundColor: "#FFECB3",
    //                     color: "#FF6F00",
    //                     borderRadius: "12px",
    //                     padding: "0px 4px",
    //                     marginLeft: "4px",
    //                     fontSize: "7px",

    //                     position: "absolute",
    //                     top: "1px",
    //                     right: "-48px",
    //                 }}
    //             >
    //                 Coming Soon
    //             </span>
    //         </span>
    //     ) as unknown as string,

    //     panelID: "Settings-1",
    //     disabled: true,
    // },
];

export const FormLoadingSkeleton = () => {
    return (
        <div style={{ paddingLeft: "13px" }}>
            <div style={{ marginTop: "10px" }}>
                <div
                    style={{
                        width: "55%",
                        marginBottom: "7px",
                    }}
                >
                    <SkeletonBodyText lines={1} />
                </div>
                <SkeletonDisplayText maxWidth={`${50}%`} />
            </div>
            <div style={{ marginTop: "10px" }}>
                <div
                    style={{
                        width: "55%",
                        marginBottom: "7px",
                    }}
                >
                    <SkeletonBodyText lines={1} />
                </div>
                <SkeletonDisplayText maxWidth={`${50}%`} />
            </div>
            <div style={{ marginTop: "10px" }}>
                <div
                    style={{
                        width: "55%",
                        marginBottom: "7px",
                    }}
                >
                    <SkeletonBodyText lines={1} />
                </div>
                <SkeletonDisplayText maxWidth={`${50}%`} />
            </div>
            <div style={{ marginTop: "10px" }}>
                <div
                    style={{
                        width: "55%",
                        marginBottom: "7px",
                    }}
                >
                    <SkeletonBodyText lines={1} />
                </div>
                <SkeletonDisplayText maxWidth={`${50}%`} />
            </div>
            <div style={{ marginTop: "10px" }}>
                <div
                    style={{
                        width: "55%",
                        marginBottom: "7px",
                    }}
                >
                    <SkeletonBodyText lines={1} />
                </div>
                <SkeletonDisplayText maxWidth={`${50}%`} />
            </div>
        </div>
    );
};

export const PreviewLoadingSkeleton = () => {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                backgroundColor: "white",
                padding: "10px",
                borderRadius: "12px",
            }}
        >
            <div style={{ margin: "0 auto 10px auto" }}>
                <div
                    style={{
                        width: "150px",
                        textAlign: "center",
                    }}
                >
                    <SkeletonDisplayText maxWidth={`${100}%`} />
                </div>
            </div>

            <div style={{ display: "flex", gap: "10px" }}>
                <div style={{ width: "30px", marginRight: "10px" }}>
                    <SkeletonThumbnail size={"small"} />
                </div>
                <div
                    style={{
                        width: "700px",
                        marginBottom: "7px",
                        marginRight: "80px",
                    }}
                >
                    <SkeletonDisplayText maxWidth={`${100}%`} />
                </div>
                <SkeletonBodyText lines={2} />
            </div>

            <div
                style={{
                    textAlign: "center",
                    margin: "12px 0",
                    fontSize: "16px",
                    color: "#e3e3e3",
                }}
            >
                +
            </div>

            <div style={{ display: "flex", gap: "10px" }}>
                <div style={{ width: "30px", marginRight: "10px" }}>
                    <SkeletonThumbnail size={"small"} />
                </div>
                <div
                    style={{
                        width: "700px",
                        marginBottom: "20px",
                        marginRight: "80px",
                    }}
                >
                    <SkeletonDisplayText maxWidth={`${100}%`} />
                </div>
                <SkeletonBodyText lines={2} />
            </div>

            <div style={{ display: "flex", marginTop: "10px" }}>
                <div
                    style={{
                        width: "100%",
                    }}
                >
                    <SkeletonDisplayText maxWidth={`${100}%`} />
                </div>
            </div>
        </div>
    );
};

const FormPreviewWrapper2 = ({
    bundleType,
    disabledTabs = false,
    renderForms,
    renderPreview,
    bundleConfig,
    oldBundleConfig,
    resetForm = () => {},
    setSelected = () => {},
    loading = false,
    globalErrors,
    globalDirty,
    selected,
    handleNext,
    dispatchBundleConfig,
    setConfig,
    validateForm,
    makeCleanForm,
    submitForm,
    forAiBundle,
    formPreviewWrapperRef,
    onlyPreview,
    _setSavingBundle = () => {},
    inspectorMode = false,
    setInspectorMode = () => {},
    setPreviewType,
}: Props_FormPreviewWrapper2) => {
    const [showLimitPopup, setShowLimitPopup] = useState(false);
    const goTo = useNavigate();
    const [activatingBundle, setActivatingBundle] = useState(false);
    const [savingBundle, setSavingBundle] = useState(false);
    const { publishCount, setPublishCount } = useContext(AppsContext);
    const { plansInfo, sft, globalSettingsInfo } = useContext(AppConfigContext);
    const { isExhausted, currentPlan, currentOrders, isTrial } = plansInfo;
    const [duplicateConfirmModal, setDuplicateConfirmModal] = useState(false);
    const [newBundleTitle, setNewBundleTitle] = useState("");
    const [duplicateErr] = useState("");
    const [duplicatingBundle, setDuplicatingBundle] = useState(false);
    const [duplicateBundleLoading, setDuplicateBundleLoading] = useState(false);
    const [showStoreModal, setShowStoreModal] = useState<boolean>(false);
    const [previewLink, setPreviewLink] = useState("");
    const [active, setActive] = useState(false);
    const [showPostPublishModal, setShowPostPublishModal] = useState(false);
    const platform = usePlatform();

    // 1 -> mobile, 2 -> desktop
    const [selectedPreviewView, setSelectedPreviewView] = useState(1);

    // console._log(setIsMobile);

    useEffect(() => {
        if (!loading) {
            // @ts-expect-error hack
            setPublishCount(bundleConfig.publish_count || 0);
        }
    }, [loading]);

    useEffect(() => {
        if (!currentPlan || Object.keys(currentPlan).length === 0) {
            handleRedirectToPlan();
        }
    }, [currentPlan]);

    const handleRedirectToPlan = () => {
        goTo("/billing");
    };

    const { trackFormMenu, trackInspectorModeToggle } = useBundleMixpanelHook();
    useEffect(() => {
        if (globalDirty) {
            shopify.saveBar.show("bundle-save-bar");
        } else {
            shopify.saveBar.hide("bundle-save-bar");
        }
    }, [globalDirty]);
    const handleInspectorToggle = () => {
        if (loading) return;
        const newMode = !inspectorMode;

        setInspectorMode(newMode);

        trackInspectorModeToggle({
            bundleType: bundleConfig?.bundle_type || "",
            ctaType: "Toggle Inspector",
            cta: "Inspector Mode Toggle",
            inspectorMode: newMode,
        });
    };

    useEffect(() => {
        if (formPreviewWrapperRef)
            formPreviewWrapperRef.current = {
                handleBundleSave,
                loader: savingBundle,
                disabled: savingBundle || activatingBundle || loading,
            };
    }, [bundleConfig, savingBundle, activatingBundle, loading]);

    const handleTabChange = useCallback((selectedTabIndex: number) => {
        handleNext(selectedTabIndex, tabs[selectedTabIndex]?.content);
    }, []);

    const handleBundleSave = async (param = { src: "Form Menu" }) => {
        submitForm();
        if (validateForm().length) {
            scrollToTop();
            return;
        }

        trackFormMenu({
            ctaType: "Save",
            cta: param?.src || "-",
            bundleType: bundleConfig?.bundle_type || "",
        });
        setSavingBundle(true);
        if (!bundleConfig?.form_id) {
            setInspectorMode(false);
        }
        const updatedBundleConfig = { ...bundleConfig };

        const res = await postData({
            url: bundleConfig?.form_id ? endPoints.updateBundle : endPoints.saveBundle,
            payload: { ...updatedBundleConfig },
        });

        if (res.status === 200 || res.status === 201) {
            makeCleanForm();
            if (res?.data?.hasOwnProperty("product_handle") && res?.data?.hasOwnProperty("product_bundle_id")) {
                setConfig((ps: any) => ({
                    ...ps,
                    bundle_as_product: { ...ps.bundle_as_product, product_handle: res?.data.product_handle ?? "" },
                    product_bundle_id: res?.data?.product_bundle_id,
                }));
                dispatchBundleConfig({
                    payload: {
                        product_handle: res?.data.product_handle ?? "",
                    },
                    isComplex: true,
                    key: "bundle_as_product",
                });
                dispatchBundleConfig({
                    payload: res?.data?.product_bundle_id,
                    key: "product_bundle_id",
                });
            }
            if (!bundleConfig?.form_id) {
                dispatchBundleConfig({
                    payload: res.data.data,
                    key: "form_id",
                });
                setConfig((ps: any) => ({ ...ps, form_id: res.data.data }));
            } else {
                setConfig({ ...bundleConfig });
            }
            shopify.saveBar.hide("bundle-save-bar");
            if (forAiBundle) {
                //goTo
            } else {
                goTo(getBundleRoute(bundleType, res.data.data || bundleConfig?.form_id));
            }
            shopify.toast.show("Data saved successfully.", {
                isError: false,
                duration: 1500,
            });
            // --- metafield update done AFTER save (async) ---
            // Always sync all entries from current swatchesProductsMap (no old/new comparison)
            const changedSwatches = generateSwatchConfigsFromProductMap((bundleConfig as any)?.swatchesProductsMap);

            if (changedSwatches.length > 0) {
                const grouped: Record<string, any[]> = {};

                changedSwatches.forEach((item) => {
                    if (!grouped[item.productId]) grouped[item.productId] = [];
                    grouped[item.productId].push(item);
                });

                const payload = {
                    kefi_swatches: Object.values(grouped).map((group) => ({
                        options: group,
                    })),
                };

                await postData({
                    url: endPoints.updateSwatchesMeta,
                    payload,
                });
            }
        } else if (
            res?.status === 400 &&
            res?.data?.message &&
            res?.data?.message.includes("Handle") &&
            res?.data?.message.includes("is already in use by another page")
        ) {
            // Show specific toast for handle conflict
            shopify.toast.show(res?.data?.message, {
                isError: true,
                duration: 8000,
            });
        } else {
            shopify.toast.show("Failed to save data. Please try again.", {
                isError: true,
                duration: 2000,
            });
        }
        _setSavingBundle(false);
        setSavingBundle(false);
    };

    const handleActivate = async (currentStatus: boolean, form_id = "") => {
        if (!isTrial && isExhausted && !currentStatus) {
            setShowLimitPopup(true);
            return;
        }
        if (!form_id) {
            return;
        }
        setActivatingBundle(true);
        // console._log(activatingBundle);
        trackFormMenu({
            cta: "Form Menu",
            ctaType: currentStatus ? "Deactivating" : "Activating",
            bundleType: bundleConfig?.bundle_type || "",
        });
        try {
            if (!currentStatus) {
                const isExtensionEnabled = await getData({
                    url: endPoints.extensionStatus,
                });
                if (isExtensionEnabled.data.status == 0) {
                    setShowEnableCoreSnippetModal(true);
                    return;
                }
            }

            const res = await postData({
                url: endPoints.updateBundleStatus,
                payload: {
                    form_id: form_id,
                    status: !currentStatus,
                    delete: false,
                },
            });

            if (res.status === 200 || res.status === 201) {
                if (!currentStatus && publishCount != null && publishCount == 0) {
                    setShowPostPublishModal(true);
                }
                dispatchBundleConfig({
                    payload: currentStatus ? false : true,
                    key: "status",
                });
                dispatchBundleConfig({
                    payload: {
                        product_status: currentStatus ? "DRAFT" : "ACTIVE",
                    },
                    isComplex: true,
                    key: "bundle_as_product",
                });

                shopify.toast.show("Bundle status updated successfully!", {
                    isError: false,
                });
            } else {
                shopify.toast.show("Failed to update bundle status. Please try again.", {
                    isError: true,
                });
            }
        } catch (error) {
            shopify.toast.show("An error occurred while updating bundle status. Please try again.", {
                isError: true,
            });
        } finally {
            setActivatingBundle(false);
            setActive(false);
        }
    };

    const handleDuplicate = async (name = "") => {
        setDuplicateBundleLoading(true);

        if (!name) {
            setDuplicateConfirmModal(true);
            setDuplicateBundleLoading(false);
            return;
        }
        trackFormMenu({
            cta: "Form Menu",
            ctaType: "Duplicate Bundle",
            bundleType: bundleConfig?.bundle_type || "",
        });
        setDuplicatingBundle(true);

        try {
            const res = await postData({
                url: endPoints.saveBundle,
                payload: {
                    ...bundleConfig,
                    title: name,
                    offer_name: "",
                    bundle_embed_id: generateRandomUniqueId(),
                    ...((bundleConfig.bundle_type === BundleTypes.STANDARD ||
                        bundleConfig.bundle_type === BundleTypes.BXGY ||
                        bundleConfig.bundle_type === BundleTypes.MIX_MATCH_SECTIONAL) && {
                        bundle_as_product: {
                            ...bundleConfig.bundle_as_product,
                            product_title: name,
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            images: bundleConfig.bundle_as_product.images.map((image: any) => {
                                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                const { id, altText, ...rest } = image;
                                return {
                                    ...rest,
                                    mediaContentType: "IMAGE",
                                };
                            }),
                        },
                    }),
                },
            });

            if (res.status === 200) {
                shopify.toast.show("Bundle duplicated successfully", {
                    isError: false,
                });
                setDuplicateConfirmModal(false);
                if (res?.data?.data) {
                    goTo(getBundleRoute(bundleConfig.bundle_type, res.data?.data));
                }
            } else if (res.status === 400) {
                shopify.toast.show("Error duplicating bundle", {
                    isError: true,
                });
            }
        } catch (error) {
            shopify.toast.show("An unexpected error occurred", {
                isError: true,
            });
        } finally {
            setDuplicatingBundle(false);
            setDuplicateBundleLoading(false);
            setNewBundleTitle("");
        }
    };

    const handleStoreModalDisplay = (link = "") => {
        // Check if we need to show the modal
        const countKey = `bundle_settings_${bundleType}`;
        const settingsObj = globalSettingsInfo?.globalSettings?.[countKey];
        if (settingsObj?.show_on_store_modal_count === 0) {
            if (link) setPreviewLink(link);
            setShowStoreModal(true);
            postData({
                url: endPoints.updateBundleSettings,
                payload: {
                    bundle_type: bundleType,
                    bundles_settings: {
                        show_on_store_modal_count: 1,
                    },
                },
            });
            // Update local context so it doesn't trigger again
            settingsObj.show_on_store_modal_count = 1;
        }
    };

    const getPreviewUrl = async (): Promise<string> => {
        let previewUrl = "";

        trackFormMenu({
            cta: "Form Menu",
            ctaType: "Show on Store",
            bundleType: bundleConfig?.bundle_type || "",
        });
        if (bundleConfig?.bundle_type == BundleTypes.BUNDLE_BUILDER && "bundle_builder_link" in bundleConfig) {
            previewUrl = `${bundleConfig?.bundle_builder_link}`;
        } else if (bundleConfig?.bundle_type == BundleTypes.BB_PLACEHOLDER) {
            const shopBase = `https://${shopify.config.shop}`;
            const bundleHandle = (bundleConfig as PlaceholderConfigInterface)?.bundle_as_product?.product_handle;
            if (bundleHandle) {
                previewUrl = `${shopBase}/products/${bundleHandle}`;
            } else if (bundleConfig?.limit_show_offer_cta == "all" || bundleConfig?.limit_show_offer_cta == "none") {
                const currentStep =
                    bundleConfig?.steps[0]?.enable_subSteps && (bundleConfig?.steps?.[0]?.subSteps?.length as any) > 0
                        ? bundleConfig?.steps[0]?.subSteps?.[0]
                        : bundleConfig?.steps[0];

                if (currentStep?.product_selection === "collection") {
                    const handle = window.localStorage.getItem("placeholder_handle");
                    if (handle) {
                        previewUrl = `${shopBase}/products/${handle}`;
                    }
                } else if (currentStep?.product_selection === "specific") {
                    const handle = currentStep?.products?.[0]?.handle;
                    if (handle) {
                        previewUrl = `${shopBase}/products/${handle}`;
                    }
                } else {
                    previewUrl = shopBase;
                }
            } else if (bundleConfig?.limit_show_offer_cta == "products") {
                if (bundleConfig.show_offer_cta_pages.length > 0) {
                    const handle = bundleConfig.show_offer_cta_pages[0].handle || "";
                    previewUrl = `${shopBase}/products/${handle}`;
                } else {
                    previewUrl = shopBase;
                }
            } else if (bundleConfig?.limit_show_offer_cta == "collections") {
                if (bundleConfig.show_offer_cta_pages.length > 0) {
                    const productsList = await fetchCollectionProducts(
                        bundleConfig.show_offer_cta_pages?.[0]?.id?.split("/")?.pop() || "",
                        sft,
                        () => {},
                        false,
                        1,
                    );
                    if (productsList.products.length > 0) {
                        const handle = productsList.products[0]?.handle || "";
                        previewUrl = `${shopBase}/products/${handle}`;
                    } else {
                        const handle = bundleConfig.show_offer_cta_pages[0].handle || "";
                        previewUrl = `${shopBase}/collections/${handle}`;
                    }
                } else {
                    previewUrl = shopBase;
                }
            }
        }
        return previewUrl;
    };

    const handlePreview = async () => {
        const url = await getPreviewUrl();
        handleStoreModalDisplay(url);
        window.open(url, "_blank");
    };

    const [previewBtnLoading, setPreviewBtnLoading] = useState<boolean>(false);
    const [showEnableCoreSnippetModalForDraftPreview, setShowEnableCoreSnippetModalForDraftPreview] =
        useState<boolean>(false);
    const handleDraftPreview = async () => {
        setPreviewBtnLoading(true);
        const isExtensionEnabled = await getData({
            url: endPoints.extensionStatus,
        });
        if (isExtensionEnabled.data.status == 0) {
            setPreviewBtnLoading(false);
            setShowEnableCoreSnippetModalForDraftPreview(true);
            return;
        }
        const fId = bundleConfig?.form_id;
        if (bundleConfig?.bundle_type == BundleTypes.BUNDLE_BUILDER && "bundle_builder_link" in bundleConfig) {
            window.open(`${bundleConfig?.bundle_builder_link}?form_id=${fId}`, "_blank");
        } else if (bundleConfig?.bundle_type == BundleTypes.BB_PLACEHOLDER) {
            if (bundleConfig?.limit_show_offer_cta == "all" || bundleConfig?.limit_show_offer_cta == "none") {
                const currentStep =
                    bundleConfig?.steps[0]?.enable_subSteps && (bundleConfig?.steps?.[0]?.subSteps?.length as any) > 0
                        ? bundleConfig?.steps[0]?.subSteps?.[0]
                        : bundleConfig?.steps[0];

                if (currentStep?.product_selection === "collection") {
                    const handle = window.localStorage.getItem("placeholder_handle");
                    if (handle) {
                        window.open(`https://${shopify.config.shop}/products/${handle}?form_id=${fId}`, "_blank");
                    }
                } else if (currentStep?.product_selection === "specific") {
                    const handle = currentStep?.products?.[0]?.handle;
                    if (handle) {
                        window.open(`https://${shopify.config.shop}/products/${handle}?form_id=${fId}`, "_blank");
                    }
                } else {
                    window.open(`https://${shopify.config.shop}?form_id=${fId}`, "_blank");
                }
            } else if (bundleConfig?.limit_show_offer_cta == "products") {
                if (bundleConfig.show_offer_cta_pages.length > 0) {
                    const handle = bundleConfig.show_offer_cta_pages[0].handle || "";
                    window.open(`https://${shopify.config.shop}/products/${handle}?form_id=${fId}`, "_blank");
                } else {
                    window.open(`https://${shopify.config.shop}?form_id=${fId}`, "_blank");
                }
            } else if (bundleConfig?.limit_show_offer_cta == "collections") {
                if (bundleConfig.show_offer_cta_pages.length > 0) {
                    const productsList = await fetchCollectionProducts(
                        bundleConfig.show_offer_cta_pages?.[0]?.id?.split("/")?.pop() || "",
                        sft,
                        () => {},
                        false,
                        1,
                    );
                    if (productsList.products.length > 0) {
                        const handle = productsList.products[0]?.handle || "";
                        window.open(`https://${shopify.config.shop}/products/${handle}?form_id=${fId}`, "_blank");
                    } else {
                        const handle = bundleConfig.show_offer_cta_pages[0].handle || "";
                        window.open(`https://${shopify.config.shop}/collections/${handle}?form_id=${fId}`, "_blank");
                    }
                } else {
                    window.open(`https://${shopify.config.shop}?form_id=${fId}`, "_blank");
                }
            }
        }
        setPreviewBtnLoading(false);
    };

    const handleDiscard = (param = { src: "Top Bar" }) => {
        trackFormMenu({
            cta: param?.src || "-",
            ctaType: "Discard",
            bundleType: bundleConfig?.bundle_type || "",
        });
        resetForm();
        dispatchBundleConfig({
            type: ChangeEvents.initState,
            init: {
                ...oldBundleConfig,
            },
        });
        shopify.saveBar.hide("bundle-save-bar");
        if (selected != 0) {
            setSelected(0);
        }
    };

    const getTooltipContent = () => {
        if (globalDirty) {
            return (
                <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>Please save the offer first!</span>
            );
        }

        if (bundleConfig?.form_id?.length > 0 && bundleConfig?.product_bundle_id == "") {
            return (
                <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    Please restore the product first!
                </span>
            );
        }

        return "";
    };

    const shakeSaveBar = () => {
        const saveBar = document.getElementById("bundle-save-bar");
        if (saveBar) {
            shopify.saveBar.leaveConfirmation();
        }
    };
    const tooltipContent = getTooltipContent();

    const [showEnableCoreSnippetModal, setShowEnableCoreSnippetModal] = useState<boolean>(false);

    const [openBBTemplateModal, setOpenBBTemplateModal] = useState(false);

    const { bId } = useParams();

    return (
        <div className={styles.formOuterWrapper}>
            <div className={styles.formPreviewWrapper} id="formPreviewWrapper2" key={bundleType}>
                <div
                    style={{
                        backgroundColor: forAiBundle ? "transparent" : "#f1f1f1",
                        position: "sticky",
                        top: "0",
                        zIndex: "110",
                        paddingBottom: forAiBundle ? 0 : "16px",
                    }}
                >
                    {!forAiBundle && (
                        <div className={styles.metaBarWrapper}>
                            <div className={styles.metaBarWrapperLeft}>
                                <div
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (!globalDirty) {
                                            trackFormMenu({
                                                cta: "Form Menu",
                                                ctaType: "Back",
                                                bundleType: bundleConfig?.bundle_type || "",
                                            });
                                            goTo(
                                                bundleConfig?.form_id?.length
                                                    ? getBundleRoute(BundleTypes.OFFERS)
                                                    : getBundleRoute("/"),
                                            );
                                        } else {
                                            shopify.saveBar.leaveConfirmation();
                                        }
                                    }}
                                    className={styles.backBtn}
                                >
                                    <ArrowLeftIcon width={18} />
                                </div>
                                <span className={styles.bundleName}>
                                    {bId ? `Edit ${getBundleType(bundleType)}` : `Create ${getBundleType(bundleType)}`}
                                </span>{" "}
                                {!!bundleConfig?.form_id?.length && (
                                    <>
                                        {getBoolean(bundleConfig?.status) ? (
                                            isBundleScheduled(bundleConfig.start_date) ? (
                                                <Badge tone="attention">Scheduled</Badge>
                                            ) : isBundleExpired(bundleConfig.end_date) ? (
                                                <Badge>Expired</Badge>
                                            ) : bundleConfig?.is_paused ? (
                                                <Tooltip
                                                    content={
                                                        "This offer is currently paused because you’ve reached your plan limit. Once you upgrade your plan, the offer will be published automatically"
                                                    }
                                                >
                                                    <Badge tone={"warning"}>Paused</Badge>
                                                </Tooltip>
                                            ) : (
                                                <Badge tone="success">Active</Badge>
                                            )
                                        ) : (
                                            <Badge tone="info">Draft</Badge>
                                        )}
                                    </>
                                )}
                            </div>

                            {/* Action buttons */}
                            <div className={styles.metaBarWrapperRight}>
                                {getBoolean(bundleConfig.status) && (
                                    <span className={`${styles.secondaryBtn} ${styles.duplicateButton}`}>
                                        <Button
                                            onClick={() => {
                                                handlePreview();
                                            }}
                                            disabled={
                                                !bundleConfig.status ||
                                                !bundleConfig?.form_id?.length ||
                                                loading ||
                                                globalDirty
                                            }
                                        >
                                            Show on Store
                                        </Button>
                                    </span>
                                )}
                                {!getBoolean(bundleConfig.status) && bundleConfig?.form_id?.length > 0 && (
                                    <span className={`${styles.secondaryBtn} ${styles.duplicateButton}`}>
                                        <Button
                                            onClick={() => {
                                                handleDraftPreview();
                                            }}
                                            disabled={!bundleConfig?.form_id?.length || loading || globalDirty}
                                            loading={previewBtnLoading}
                                        >
                                            Preview on Store
                                        </Button>
                                    </span>
                                )}
                                <span className={`${styles.secondaryBtn} ${styles.duplicateButton}`}>
                                    <Button
                                        onClick={() => {
                                            trackFormMenu({
                                                cta: "Form Menu",
                                                ctaType: "Duplicate Modal Triggered",
                                                bundleType: bundleConfig?.bundle_type || "",
                                            });
                                            setDuplicateConfirmModal(true);
                                        }}
                                        disabled={
                                            !bundleConfig?.form_id?.length ||
                                            duplicatingBundle ||
                                            loading ||
                                            globalDirty
                                        }
                                    >
                                        Duplicate
                                    </Button>
                                </span>

                                {tooltipContent ? (
                                    <Tooltip content={tooltipContent} preferredPosition="above">
                                        <div
                                            onClick={() => {
                                                if (globalDirty) {
                                                    shakeSaveBar();
                                                }
                                            }}
                                            style={{ display: "inline-block" }}
                                        >
                                            <Button
                                                variant="primary"
                                                onClick={() => {
                                                    handleActivate(
                                                        !!getBoolean(bundleConfig.status),
                                                        bundleConfig?.form_id,
                                                    );
                                                }}
                                                loading={activatingBundle}
                                                disabled={
                                                    !bundleConfig?.form_id?.length ||
                                                    activatingBundle ||
                                                    loading ||
                                                    globalDirty ||
                                                    (bundleConfig?.form_id?.length > 0 &&
                                                        bundleConfig?.product_bundle_id == "")
                                                }
                                            >
                                                {getBoolean(bundleConfig.status) ? "Unpublish" : "Publish"}
                                            </Button>
                                        </div>
                                    </Tooltip>
                                ) : (
                                    <Button
                                        variant="primary"
                                        onClick={() => {
                                            handleActivate(!!getBoolean(bundleConfig.status), bundleConfig?.form_id);
                                        }}
                                        loading={activatingBundle}
                                        disabled={
                                            !bundleConfig?.form_id?.length || activatingBundle || loading || globalDirty
                                        }
                                    >
                                        {getBoolean(bundleConfig.status) ? "Unpublish" : "Publish"}
                                    </Button>
                                )}

                                {showEnableCoreSnippetModal && (
                                    <ActivateSnippetModal
                                        setShowEnableCoreSnippetModal={setShowEnableCoreSnippetModal}
                                        onSnippetEnabled={() =>
                                            handleActivate(!!getBoolean(bundleConfig.status), bundleConfig?.form_id)
                                        }
                                    />
                                )}
                                {showEnableCoreSnippetModalForDraftPreview && (
                                    <ActivateSnippetModal
                                        setShowEnableCoreSnippetModal={setShowEnableCoreSnippetModalForDraftPreview}
                                        onSnippetEnabled={() => handleDraftPreview()}
                                    />
                                )}
                                {/* <PostPublishCard
                                    handlePreview={handlePreview}
                                    setShowPostPublishModal={setShowPostPublishModal}
                                    showPostPublishModal={showPostPublishModal}
                                    showPoweredByKefi={!!bundleConfig?.general_settings?.show_powered_by_kefi}
                                /> */}

                                {/* Small screen action buttons  */}
                                <div className={styles.moreActionsIcon}>
                                    <Popover
                                        active={active}
                                        activator={
                                            <div onClick={() => setActive((active) => !active)}>
                                                <Icon source={MenuHorizontalIcon} tone="base"></Icon>
                                            </div>
                                        }
                                        autofocusTarget="first-node"
                                        onClose={() => setActive((active) => !active)}
                                    >
                                        <ActionList
                                            actionRole="menuitem"
                                            items={[
                                                {
                                                    prefix: <Icon source={DuplicateIcon} tone="base" />,
                                                    content: "Duplicate",
                                                    onAction: () => {
                                                        trackFormMenu({
                                                            cta: "Form Menu",
                                                            ctaType: "Duplicate Modal Triggered",
                                                            bundleType: bundleConfig?.bundle_type || "",
                                                        });
                                                        setDuplicateConfirmModal(true);
                                                    },
                                                    disabled:
                                                        !bundleConfig?.form_id?.length ||
                                                        duplicatingBundle ||
                                                        loading ||
                                                        globalDirty,
                                                },
                                                {
                                                    prefix: <Icon source={StatusActiveIcon} tone="base" />,
                                                    content: getBoolean(bundleConfig.status)
                                                        ? "Deactivate"
                                                        : "Activate",
                                                    disabled:
                                                        !bundleConfig?.form_id?.length ||
                                                        activatingBundle ||
                                                        loading ||
                                                        globalDirty,
                                                    onAction: () => {
                                                        handleActivate(
                                                            !!getBoolean(bundleConfig.status),
                                                            bundleConfig?.form_id,
                                                        );
                                                    },
                                                },
                                                {
                                                    prefix: <Icon source={ViewIcon} tone="base" />,
                                                    content: "Show on Store",
                                                    disabled:
                                                        !bundleConfig.status ||
                                                        !bundleConfig?.form_id?.length ||
                                                        loading ||
                                                        globalDirty,
                                                    onAction: () => handlePreview(),
                                                },
                                            ]}
                                        />
                                    </Popover>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <RenderError submitErrors={globalErrors} />
                <BundleAsProductError bundleConfig={bundleConfig} />

                {!loading && bundleConfig?.form_id?.length > 0 && bundleConfig?.product_bundle_id == "" && (
                    <div style={{ marginBottom: 14 }}>
                        <Banner title="This bundle may not work properly" tone="warning">
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <span>The bundle product was deleted from your Shopify store.</span>

                                <Button
                                    variant="secondary"
                                    onClick={() => handleBundleSave({ src: "Restore Button" })}
                                    loading={savingBundle}
                                >
                                    Restore
                                </Button>
                            </div>
                        </Banner>
                    </div>
                )}

                <div
                    className={styles.panels}
                    style={
                        loading && !onlyPreview
                            ? {}
                            : onlyPreview
                              ? {
                                    margin: "auto",
                                    display: "flex",
                                    justifyContent: "center",
                                    minWidth: "240px",
                                    maxWidth: "400px",
                                }
                              : forAiBundle
                                ? {
                                      padding: "1rem",
                                      background: "#f1f1f1",
                                  }
                                : {}
                    }
                >
                    {!onlyPreview && (
                        <div className={styles.leftSection}>
                            <Tabs
                                tabs={tabs}
                                selected={selected}
                                onSelect={handleTabChange}
                                disabled={disabledTabs || loading}
                            >
                                <div
                                    className={styles.selectedTabPanel}
                                    style={{
                                        pointerEvents: loading ? "none" : "all",
                                    }}
                                >
                                    {loading ? <FormLoadingSkeleton /> : renderForms[selected]}
                                </div>
                            </Tabs>

                            {/* <div className={styles.badgeContainer}>
                            <Badge progress="incomplete" tone="attention">
                                Coming Soon
                            </Badge>
                        </div> */}

                            {/* <div className={styles.comingSoonBadge}>
                            Coming Soon
                        </div> */}
                        </div>
                    )}
                    <div
                        className={styles.rightSection}
                        id="rightSectionContainerId"
                        style={{ top: forAiBundle ? 69 : 64 }}
                    >
                        {!loading &&
                            bundleConfig?.form_id?.length > 0 &&
                            bundleConfig?.product_bundle_id?.length > 0 && (
                                <ProductIntent
                                    bundleConfig={bundleConfig}
                                    bundle_as_product={bundleConfig?.bundle_as_product}
                                    product_bundle_id={bundleConfig?.product_bundle_id || ""}
                                    dispatchBundleConfig={dispatchBundleConfig}
                                    setConfig={setConfig}
                                    shakeSaveBar={shakeSaveBar}
                                    globalDirty={globalDirty}
                                    setSavingBundle={setSavingBundle}
                                    product_title={bundleConfig?.title}
                                />
                            )}

                        <div
                            className={styles.preview}
                            id={bundleType == BundleTypes.BB_PLACEHOLDER ? "bb_placeholderPreview" : ""}
                        >
                            {!onlyPreview && (
                                <div
                                    className={styles.previewWidgetTitle}
                                    style={{
                                        color: loading ? "#b5b5b5" : "#4a4a4a",
                                    }}
                                >
                                    <ButtonGroup variant="segmented">
                                        <Button
                                            pressed={!inspectorMode}
                                            onClick={() => {
                                                if (inspectorMode) {
                                                    handleInspectorToggle();
                                                }
                                            }}
                                            disabled={savingBundle || activatingBundle || loading}
                                        >
                                            Preview
                                        </Button>

                                        <Button
                                            pressed={inspectorMode}
                                            onClick={() => {
                                                if (!inspectorMode) {
                                                    handleInspectorToggle();
                                                }
                                            }}
                                            disabled={savingBundle || activatingBundle || loading}
                                            children={
                                                <>
                                                    <span className={styles.inspectorModeToggleWrapper}>
                                                        Design Editor
                                                        <Tooltip
                                                            width="wide"
                                                            preferredPosition="above"
                                                            content={
                                                                <div className={styles.tooltipContent}>
                                                                    <div className={styles.mainTooltipText}>
                                                                        <span className={styles.shortcut}>
                                                                            To edit styles:
                                                                        </span>{" "}
                                                                        Click any element.
                                                                    </div>
                                                                    <div className={styles.tooltipText}>
                                                                        Tip: Hold{" "}
                                                                        <span
                                                                            className={styles.shortcut}
                                                                            style={{
                                                                                display: "inline-flex",
                                                                                alignItems: "center",
                                                                                gap: "2px",
                                                                            }}
                                                                        >
                                                                            {platform === "Mac" ? (
                                                                                <MdOutlineKeyboardCommandKey
                                                                                    size={13}
                                                                                    style={{
                                                                                        position: "relative",
                                                                                        top: "2px",
                                                                                    }}
                                                                                />
                                                                            ) : (
                                                                                "Ctrl"
                                                                            )}{" "}
                                                                        </span>{" "}
                                                                        <span className={styles.shortcut}>
                                                                            {" "}
                                                                            + Click
                                                                        </span>{" "}
                                                                        to interact with the element normally without
                                                                        leaving Editor Mode.
                                                                    </div>
                                                                </div>
                                                            }
                                                        >
                                                            <span className={styles.infoIcon}>
                                                                <InfoIconOverride size={14} />
                                                            </span>
                                                        </Tooltip>
                                                    </span>
                                                </>
                                            }
                                        />
                                    </ButtonGroup>

                                    {inspectorMode &&
                                        [BundleTypes?.BUNDLE_BUILDER, BundleTypes.BB_PLACEHOLDER]?.includes(
                                            bundleType as any,
                                        ) &&
                                        (bundleConfig.steps[0]?.enable_subSteps
                                            ? bundleConfig.steps[0].subSteps?.[0]?.product_selection == "specific"
                                                ? bundleConfig.steps[0].subSteps?.[0]?.products?.length >= 1
                                                : // @ts-ignore
                                                  bundleConfig.steps[0].subSteps?.[0]?.collections?.length >= 1
                                            : bundleConfig.steps[0].product_selection == "specific"
                                              ? bundleConfig.steps[0].products.length >= 1
                                              : bundleConfig.steps[0].collections.length >= 1) && (
                                            <Button
                                                onClick={() => setOpenBBTemplateModal(true)}
                                                variant="plain"
                                                disabled={savingBundle || activatingBundle || loading}
                                            >
                                                Change Template
                                            </Button>
                                        )}

                                    {!inspectorMode &&
                                        [BundleTypes?.BUNDLE_BUILDER, BundleTypes.BB_PLACEHOLDER]?.includes(
                                            bundleType as any,
                                        ) && (
                                            <span
                                                style={{
                                                    display: "flex",
                                                }}
                                            >
                                                <span
                                                    onClick={() => {
                                                        setSelectedPreviewView(1);
                                                        setPreviewType(1);
                                                    }}
                                                    style={{
                                                        cursor: "pointer",
                                                        backgroundColor:
                                                            selectedPreviewView === 1 ? "#dddddd" : "#ffffff",
                                                        borderRadius: "6px",
                                                        padding: "2px",
                                                    }}
                                                >
                                                    <Tooltip content={"Mobile View"}>
                                                        <Icon source={MobileIcon} tone={loading ? "subdued" : "base"} />
                                                    </Tooltip>
                                                </span>

                                                <span
                                                    onClick={() => {
                                                        setSelectedPreviewView(2);
                                                        setPreviewType(2);
                                                    }}
                                                    style={{
                                                        cursor: "pointer",
                                                        backgroundColor:
                                                            selectedPreviewView === 2 ? "#dddddd" : "#ffffff",
                                                        borderRadius: "6px",
                                                        padding: "2px",
                                                    }}
                                                >
                                                    <Tooltip content={"Desktop View"}>
                                                        <Icon
                                                            source={DesktopIcon}
                                                            tone={loading ? "subdued" : "base"}
                                                        />
                                                    </Tooltip>
                                                </span>
                                            </span>
                                        )}
                                </div>
                            )}
                            {loading ? <PreviewLoadingSkeleton /> : <>{renderPreview}</>}
                        </div>

                        {!loading && <CalloutNudgeBanner />}
                        {!onlyPreview && !loading && <SuggestFeature bundleType={bundleType} />}
                    </div>
                </div>
                <CustomModal
                    title={"Duplicate Bundle"}
                    open={duplicateConfirmModal}
                    loading={duplicateBundleLoading}
                    onClose={() => {
                        setDuplicateConfirmModal(false);
                    }}
                    primaryAction={{
                        content: "Duplicate",
                        disabled: !newBundleTitle || !!duplicateErr.length || duplicateBundleLoading,
                        onAction: () => handleDuplicate(newBundleTitle),
                    }}
                    secondaryActions={[
                        {
                            content: "Cancel",
                            onAction: () => {
                                trackFormMenu({
                                    cta: "Form Menu",
                                    ctaType: "Duplicate Modal Closed",
                                    bundleType: bundleConfig?.bundle_type || "",
                                });
                                setDuplicateConfirmModal(false);
                            },
                        },
                    ]}
                >
                    <FormLayout>
                        <TextField
                            label="Title"
                            placeholder="bundle title"
                            autoComplete=""
                            value={newBundleTitle}
                            onChange={(val) => {
                                setNewBundleTitle(val);
                            }}
                            error={duplicateErr}
                        />
                    </FormLayout>
                </CustomModal>

                {bundleConfig?.bundle_type == BundleTypes.BUNDLE_BUILDER && (
                    <BundleBuilderModalPreview
                        open={selectedPreviewView == 2}
                        onClose={() => {
                            setSelectedPreviewView(1);
                        }}
                        bundleConfig={bundleConfig as BundleBuilderConfigInterface}
                    />
                )}

                {showLimitPopup && (
                    <LimitReachedPopup
                        setPopup={setShowLimitPopup}
                        isExhausted={isExhausted}
                        currentPlan={currentPlan}
                        currentOrders={currentOrders}
                    />
                )}
                {showStoreModal && (
                    <ShowOnStoreModal
                        open={showStoreModal}
                        onClose={() => setShowStoreModal(false)}
                        bundleType={bundleType}
                        bundleLink={previewLink}
                    />
                )}
                {openBBTemplateModal && bundleType === BundleTypes.BB_PLACEHOLDER && (
                    <PlaceholderTemplate
                        openBBTemplateModal={openBBTemplateModal}
                        setOpenBBTemplateModal={setOpenBBTemplateModal}
                        bundleConfig={bundleConfig}
                        dispatchBundleConfig={dispatchBundleConfig}
                    />
                )}
                {savingBundle ? (
                    <SaveBar id="bundle-save-bar">
                        <button
                            variant="primary"
                            onClick={() => {
                                handleBundleSave({ src: "Top Bar" });
                            }}
                            disabled={savingBundle}
                            loading=""
                        >
                            Save
                        </button>
                        <button
                            onClick={() => {
                                handleDiscard({ src: "Top Bar" });
                            }}
                            disabled={savingBundle}
                        >
                            Discard
                        </button>
                    </SaveBar>
                ) : (
                    <SaveBar id="bundle-save-bar">
                        <button
                            variant="primary"
                            onClick={() => {
                                handleBundleSave({ src: "Top Bar" });
                            }}
                            disabled={savingBundle}
                        >
                            Save
                        </button>
                        <button
                            onClick={() => {
                                handleDiscard({ src: "Top Bar" });
                            }}
                            disabled={savingBundle}
                        >
                            Discard
                        </button>
                    </SaveBar>
                )}
            </div>
        </div>
    );
};

export default FormPreviewWrapper2;
